import { Checkbox, Paper } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import {
  beatNotAssignMsg,
  noInternetMsg,
  serverMsg,
} from "../../config/messageconstant";
import { dayWiseBeatDriverJson } from "../../DynamicFormsJson/Transaction/DayWiseBeatDriver";
import { getAreaByUserType } from "../../Slice/area.slice";
import {
  getBeatBySalesTeamIdAndAreaIdPost,
  getBeatBySalesTeamIdAndLoginPersonAreas,
} from "../../Slice/beat.slice";
import { getSalesExecutiveByAreaId } from "../../Slice/salesExecutive.slice";
import { apiGet } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { blackColor, checkboxColor } from "../../config/ColorObj";
class DayWiseDriverView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
      salesTeamId: "",
      dynamicMasterData: {
        areaDetail: this.props.areaList.area,
        salesExecutiveDetail: this.props.salesExecutive.salesExecutive,
      },
      matrixData: [],
      rowData: [],
      dayList: [
        {
          dayId: 0,
          name: "Monday",
        },
        {
          dayId: 1,
          name: "Tuesday",
        },
        {
          dayId: 2,
          name: "Wednesday",
        },
        {
          dayId: 3,
          name: "Thursday",
        },
        {
          dayId: 4,
          name: "Friday",
        },
        {
          dayId: 5,
          name: "Saturday",
        },
        {
          dayId: 6,
          name: "Sunday",
        },
      ],
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.beatList !== nextProps.beatList) {
      if (this.props.beatList?.beat !== nextProps.beatList?.beat) {
        this.setMatrix(nextProps.beatList?.beat);
      }
    }
    if (this.props.areaList !== nextProps.areaList) {
      if (this.props.areaList?.area !== nextProps.areaList?.area) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.area,
          },
        });
      }
    }
    if (this.props.salesExecutive !== nextProps.salesExecutive) {
      if (
        this.props.salesExecutive?.salesExecutive !==
        nextProps.salesExecutive?.salesExecutive
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            salesExecutiveDetail: nextProps.salesExecutive?.salesExecutive,
          },
        });
      }
    }
  }
  setMatrix = (beatList) => {
    const { dayList, rowData } = this.state;
    const matList = dayList.map((dayObj) => {
      let matObj = {
        ...dayObj,
      };
      let filterDay = [];
      if (rowData.length != 0) {
        filterDay = rowData.filter((rowData) => dayObj.dayId == rowData.day);
      }
      const beatListData = beatList.map((beatObj) => {
        let filterBeat = [];
        if (filterDay.length != 0) {
          filterBeat = filterDay[0].vehicleAssignDaywiseDetails.filter(
            (rowData) => beatObj.beatId == rowData.beat.id
          );
        }
        let beatDataObj = {
          ...beatObj,
          beatName: beatObj.name,
          checked: filterBeat.length != 0 ? true : false,
          disabled: true,
        };
        if (filterBeat.length != 0) {
          beatDataObj = {
            ...beatDataObj,
            id: filterBeat[0].id,
          };
        }
        return beatDataObj;
      });
      matObj = {
        ...matObj,
        beatListData: beatListData,
      };
      if (filterDay.length != 0) {
        matObj = {
          ...matObj,
          vehicle: filterDay[0].vehicle.id || "",
          vehicleNo: filterDay[0].vehicle.vehicleNo || "",
          id: filterDay[0].id,
        };
      }
      return matObj;
    });
    this.setState({
      matrixData: matList,
    });
  };
  async componentDidMount() {
    if (this.props.params.id) {
      this.getDataById(this.props.params.id);
    }
  }
  getDataById = (id) => {
    const { showLoador } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      const response = apiGet({
        url: endpoint.vehicleAssignDayWiseHeader + "/by-driver?driverId=" + id,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (!data.error) {
            let rowData = data.data;
            this.setState({
              rowData,
              DataToSet: [
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Driver Name",
                  value:
                    rowData[0].driver !== null &&
                    rowData[0].driver.name !== null
                      ? rowData[0].driver.name
                      : "",
                },
              ],
            });
            this.onSearch(rowData);

            return { data: rowData, success };
          }
          return { data: [], success: false };
        }

        return { data: [], success: false };
      });
      return response;
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearch = (data) => {
    const { getBeatBySalesTeamIdAndAreaIdPost, showLoador, showNotification } =
      this.props;
    if (navigator.onLine) {
      this.setState({
        matrixData: [],
      });
      this.setState({
        salesTeamId: this.props.params.id,
      });

      let areaIdsJson = {
        areaIds: data[0].driver.areaIds.split(","),
      };

      showLoador({ loador: true });
      getBeatBySalesTeamIdAndAreaIdPost({
        salesTeamId: data[0].driver.id,
        areaIds: areaIdsJson,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          if (response.length == 0) {
            this.props.showNotification({
              msg: beatNotAssignMsg,
              severity: "error",
            });
          }
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };
  render() {
    const { matrixData, dynamicMasterData, DataToSet, dayList } = this.state;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 2,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            DataToSet={DataToSet}
            dynamicMasterData={dynamicMasterData}
            showSaveBtn={dayWiseBeatDriverJson.showSaveBtn}
            showTitle={dayWiseBeatDriverJson.showTitle}
            screenTitle={dayWiseBeatDriverJson.screenTitle}
            fieldMeta={[]}
            showCancel={dayWiseBeatDriverJson.showCancel}
            apiBaseURL={dayWiseBeatDriverJson.apiBaseURL}
            showSaveNextBtn={dayWiseBeatDriverJson.showSaveNextBtn}
            saveBtnText={"Search"}
            showSaveBtnMain={this.props.params.id ? false : true}
          />
          <br />
          {matrixData.length != 0 && (
            <>
              <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" sx={{ width: "10%" }}>
                        Vehicle
                      </TableCell>

                      <TableCell align="center" sx={{ width: "7%" }}>
                        Days
                      </TableCell>

                      <TableCell align="center" sx={{ width: "83%" }}>
                        Beats
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {matrixData.map((matrixDataRow, indexRow) => {
                      return (
                        <TableRow>
                          <TableCell align="center">
                            {matrixDataRow.vehicleNo
                              ? matrixDataRow.vehicleNo
                              : "-"}
                          </TableCell>
                          <TableCell align="center">
                            {matrixDataRow.name}
                          </TableCell>
                          <TableCell>
                            {matrixDataRow.beatListData.map(
                              (columnName, index) => {
                                return (
                                  <FormControl component="fieldset">
                                    <FormGroup aria-label="position" row>
                                      <FormControlLabel
                                        value="end"
                                        control={
                                          <Checkbox
                                            sx={{
                                              color: blackColor,
                                              "&.Mui-checked": {
                                                color: checkboxColor,
                                              },
                                            }}
                                            disabled={columnName.disabled}
                                            checked={columnName.checked}
                                          />
                                        }
                                        label={columnName.beatName}
                                        labelPlacement="end"
                                      />
                                    </FormGroup>
                                  </FormControl>
                                );
                              }
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  areaList: state.area,
  beatList: state.beat,
  salesExecutive: state.salesExecutive,
});
const mapDispatchToProps = {
  getAreaByUserType,
  showLoador,
  showNotification,
  getSalesExecutiveByAreaId,
  getBeatBySalesTeamIdAndLoginPersonAreas,
  getBeatBySalesTeamIdAndAreaIdPost,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(DayWiseDriverView);
